import type { InlineCopy, ToastCopy } from '../feedback/toastCopy';

export const TOAST_EN: ToastCopy = {
  success: {
    login: 'Signed in. Opening operations.',
    feedbackSaved: 'Detection review saved.',
    bulkReview: (count: number) => `Confirmed ${count} candidate(s).`,
    csvExport: (count: number, total: number) => `Downloaded CSV ${count} of ${total}.`,
    trainingExport: (exported: number, isolated: number) =>
      `Training JSON: exported ${exported}, isolated ${isolated}.`,
    trainingUpload: 'Training data uploaded.',
    trainingStart: 'Model training started.',
    trainingStop: 'Training stopped.',
    trainingDelete: 'Training data deleted.',
    modelExport: 'Model downloaded.',
  },
  info: {
    csvEmpty: 'No feedback to download.',
  },
  error: {
    auth: 'Sign-in required. Please sign in again.',
    network: 'Cannot reach the server. Check the network and operations API.',
    generic: 'Could not complete the request. Try again in a moment.',
    serverBusy: 'The server is busy. Try again in a moment.',
    feedbackSubmit: 'Could not save feedback. Your input is still on screen.',
    feedbackReview: 'Could not change review status.',
    feedbackBulk: 'Could not bulk-confirm.',
    feedbackCsv: 'Could not download CSV.',
    feedbackExport: 'Could not build training JSON.',
    trainingList: 'Could not load training data.',
    trainingUpload: 'Training data upload failed.',
    trainingStart: 'Could not start training.',
    trainingStop: 'Could not stop training.',
    trainingDelete: 'Could not delete training data.',
    modelExport: 'Could not download the model.',
    login: 'Username or password is wrong. See the sign-in screen for the trial account.',
    monitoringStatus: 'Cannot reach the monitoring API. Check the API and your session.',
  },
  reviewStatus: {
    candidate: 'Candidate',
    confirmed: 'Confirmed',
    rejected: 'Rejected',
  },
};

export const INLINE_EN: InlineCopy = {
  analysis: {
    syncFailed: 'Could not load the result by analysis_id. Check Console API and the id.',
    syncFailedStatus: 'The synced analysis is in a failed state.',
    processingFailed: 'Analysis failed.',
    statusPollFailed: 'Could not check analysis status.',
    uploadCanceled: 'Upload canceled.',
    uploadFailed: 'File upload failed.',
    upload503: TOAST_EN.error.serverBusy,
  },
  dvos: {
    ackFailed: 'Ack request failed.',
    listFailed: 'Could not load DVOS events.',
  },
};
